import {Manufacturer} from './manufacturer';

export class ManufacturerCollection {
    private totalItems: number = 0;
    private manufacturers: Manufacturer[] = [];

    setTotalItems(totalItems: number) {
        this.totalItems = totalItems;
    }

    setManufacturers(manufacturers: Manufacturer[]) {
        this.manufacturers = manufacturers;
    }

    getTotalItems(): number {
        return this.totalItems;
    }

    getManufacturers(): Manufacturer[] {
        return this.manufacturers;
    }
}
